import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { withWrapper } from "create-react-server/wrapper";
import { Helmet } from "react-helmet";
import Popup from "components/Popup/Popup";

import map from "modules/map";
import library from "modules/library";
import order from "modules/order";
import Gallery from "components/Gallery/Gallery";
import dataFormatter from "utils/dataFormatter";

import "./LibraryCard.css";

const week = [
  "Понедельник",
  "Вторник",
  "Среда",
  "Четверг",
  "Пятница",
  "Суббота",
  "Воскресенье"
];

class LibraryCard extends Component {
  constructor(props) {
    super(props);
    if (typeof window !== "undefined") {
      if (window.innerWidth > 320) {
        window.scrollTo(0, 1000);
      } else {
        window.scrollTo(0, 0);
      }
    }
    this.state = {
      show: false,
      userName: "",
      email: "",
      activeService: {},
      showPopup: false
    };

    if (props.match.params.id && !props.library)
      props.selectLibrary(props.match.params.id);
    this.showGallery = this.showGallery.bind(this);
    this.closeLibrary = this.closeLibrary.bind(this);
    this.showInformation = this.showInformation.bind(this);
    this.handleBuyAction = this.handleBuyAction.bind(this);
  }

  closeLibrary() {
    this.props.history.push("/libraries/");
    this.props.closeLibrary();
    this.props.getAllLibraries();
  }

  showPayment(service) {
    this.setState({
      showPopup: true,
      activeService: service
    });
  }

  closePayment() {
    this.setState({
      showPopup: false,
      activeService: {}
    });
  }

  static async getInitialProps({
    location: { pathname, query },
    params,
    store
  }) {
    if (params && params.id)
      await store.dispatch(library.actions.asyncSelectLibrary(params.id));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id)
      nextProps.selectLibrary(nextProps.match.params.id);

    if (nextProps.formUrl && this.props.formUrl !== nextProps.formUrl) {
      window.location = nextProps.formUrl;
    }
  }

  showGallery() {
    this.setState({ show: true });
  }

  handleBuyAction() {
    const order = {
      library_id: this.props.map.libraryId,
      service_id: this.state.activeService.id,
      email: this.state.email,
      name: this.state.userName
    };

    this.props.createOrder(order);
  }

  hideGallery() {
    this.setState({ show: false });
  }

  componentWillUnmount() {
    this.props.closeLibrary();
  }

  showInformation(e) {
    if (e.target.nextElementSibling.className === "info_show") {
      e.target.nextElementSibling.className = "info_hide";
      e.target.previousElementSibling.className = "icon-arrow";
    } else {
      e.target.nextElementSibling.className = "info_show";
      e.target.previousElementSibling.className = "icon-arrow_bottom";
    }
  }

  render() {
    if (!this.props.library) return <div />;
    return (
      <div ref="libraryCard" className="library">
        {this.state.showPopup && (
          <Popup onOverlayClick={() => this.closePayment()} className={true}>
            <div className="search" style={{ width: "100%" }}>
              <div style={{ padding: "10px" }}>
                <h3>{this.state.activeService.name}</h3>
                <p
                  style={{
                    paddingBottom: "1rem"
                  }}
                >
                  {this.state.activeService.desc}
                </p>
                <div>
                  <label
                    style={{
                      flexFlow: "column nowrap",
                      alignItems: "flex-start"
                    }}
                  >
                    Ваше имя
                    <input
                      type="text"
                      onChange={e =>
                        this.setState({
                          userName: e.target.value
                        })
                      }
                    />
                  </label>
                </div>
                <div className="input-container">
                  <label
                    style={{
                      flexFlow: "column nowrap",
                      alignItems: "flex-start"
                    }}
                  >
                    Ваш email
                    <input
                      type="text"
                      onChange={e =>
                        this.setState({
                          email: e.target.value
                        })
                      }
                    />
                  </label>
                </div>
                <div style={{ textAlign: "right", paddingTop: "16px" }}>
                  <button
                    className="button"
                    style={{
                      padding: "10px",
                      backgroundColor: "#9CC6EE",
                      border: "none",
                      fontSize: "18px"
                    }}
                    onClick={this.handleBuyAction}
                  >
                    Оплатить
                  </button>
                </div>
              </div>
            </div>
          </Popup>
        )}
        <Helmet>
          <title>{this.props.library.name}</title>
        </Helmet>
        <Gallery
          data={
            this.props.library.photos ? this.props.library.photos.large : []
          }
          name={this.props.library.name}
          address={this.props.library.address}
          hideGallery={() => this.hideGallery()}
          show={this.state.show}
        />
        {Object.keys(this.props.library).length ? (
          <div>
            <div className="name">
              <p> {this.props.library.name} </p>
              <div className="close" onClick={this.closeLibrary} />
            </div>
            <div className="information-table">
              <div className="wide">
                <div className="small-title">
                  {" "}
                  {this.props.library.fullname}{" "}
                </div>
                <div className="description border">
                  {" "}
                  {this.props.library.description}{" "}
                </div>
                <div className="mobile_hidden">
                  <div className="photo-container" onClick={this.showGallery}>
                    <div className="photo">
                      {this.props.library.photos.small
                        .slice(0, 2)
                        .map((photo, index) => {
                          return (
                            <img
                              key={index}
                              src={`${
                                process.env.REACT_APP_IMG_SERVER
                              }/${photo}`}
                              alt=""
                            />
                          );
                        })}
                    </div>
                    {this.props.library.photos.small.length > 2 ? (
                      <div className="more-photo">
                        <span className="more-photo-desc">
                          {" "}
                          {this.props.library.photos.small.length} фото{" "}
                        </span>
                        <img
                          src={`${process.env.REACT_APP_IMG_SERVER}/${
                            this.props.library.photos.small[2]
                          }`}
                          alt=""
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="information-table">
                    {this.props.library.databases ? (
                      <div>
                        <div className="small-title">
                          {" "}
                          Электронные базы данных
                        </div>
                        {this.props.library.databases.map((database, index) => {
                          return (
                            <div className="list" key={index}>
                              {" "}
                              - {database}{" "}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      ""
                    )}
                    {this.props.library.children.length ? (
                      <div>
                        <div className="small-title"> Для детей</div>
                        {this.props.library.children.map((item, index) => {
                          const className = item.paid
                            ? "list list--paid"
                            : "list";
                          return (
                            <div className={className} key={index}>
                              {" "}
                              - {item.name}{" "}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      ""
                    )}
                    {this.props.library.copy.length ? (
                      <div>
                        <div className="small-title"> Копицентр</div>
                        {this.props.library.copy.map((item, index) => {
                          const className = item.paid
                            ? "list list--paid"
                            : "list";
                          return (
                            <div className={className} key={index}>
                              {" "}
                              - {item.name}{" "}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="tablet_visible">
                      {this.props.library.services.length ? (
                        <div>
                          <div className="small-title"> Услуги и курсы</div>
                          {this.props.library.services.map((service, index) => {
                            const className = service.paid
                              ? "list list--paid"
                              : "list";
                            return (
                              <div className={className} key={index}>
                                {" "}
                                - {service.name}{" "}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="narrow">
                {this.props.library.holidays ? (
                  <div className="holidays">
                    <div className="small-title">
                      {" "}
                      Режим работы в праздничные дни
                    </div>
                    {this.props.library.holidays.map((day, index) => {
                      return (
                        <div key={index} className="schedule">
                          <div> {day} </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  ""
                )}
                <div className="small-title"> Режим работы</div>
                {dataFormatter(this.props.library.schedule).map(
                  (day, index) => {
                    return (
                      <div key={index} className="schedule">
                        <div> {week[index]} </div>
                        <div> {day} </div>
                      </div>
                    );
                  }
                )}
                <div className="border">
                  <div className="small-title"> Санитарный день</div>
                  <div> {this.props.library.dayoff} </div>
                </div>
                <div className="border">
                  <div className="small-title"> Тип библиотеки</div>
                  <div> {this.props.library.type} </div>
                </div>
                <div className="border">
                  <div className="small-title"> Читальный зал</div>
                  <div> {this.props.library.hall ? "есть" : "нет"} </div>
                  <div className="icon">
                    {this.props.library.disabled ? (
                      <span className="disabled" />
                    ) : (
                      ""
                    )}
                    {this.props.library.wifi ? <span className="wifi" /> : ""}
                    {this.props.library.pc ? <span className="pc" /> : ""}
                    {this.props.library.headphones ? (
                      <span className="headphones" />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="tablet_hidden">
                  {this.props.library.services.length ? (
                    <div>
                      <div className="small-title"> Услуги и курсы</div>
                      {this.props.library.services.map((service, index) => {
                        const className = service.paid
                          ? "list list--paid"
                          : "list";
                        return (
                          <div className={className} key={index}>
                            {" "}
                            - {service.name}{" "}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="narrow">
                <div className="border">
                  <div className="small-title"> Адрес</div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.props.library.address
                    }}
                  />
                  <div className="small-title"> Ближайшее метро</div>
                  <div> {this.props.library.metro} </div>
                  <div className="description">
                    {" "}
                    {this.props.library.notes}{" "}
                  </div>
                  <div className="mobile_visible">
                    <div className="small-title"> Округ</div>
                    <div> {this.props.library.region} </div>
                    <div className="small-title"> Район</div>
                    <div> {this.props.library.district} </div>
                  </div>
                </div>
                <div className="border">
                  <div className="small-title"> Телефон</div>
                  <div> {this.props.library.phone} </div>
                </div>
                <div className="border">
                  <div className="small-title"> Сайт</div>
                  <a href={`http://${this.props.library.website}`}>
                    {" "}
                    {this.props.library.website}{" "}
                  </a>
                </div>
                {this.props.library.catalogue ? (
                  <div className="border">
                    <div className="small-title"> Электронный каталог</div>
                    <a
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block"
                      }}
                      href={`http://${this.props.library.catalogue}`}
                    >
                      {" "}
                      {this.props.library.catalogue}{" "}
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.props.library.email ? (
                  <div className="border">
                    <div className="small-title"> Электронная почта</div>
                    <a href={`mailto:${this.props.library.email}`}>
                      {" "}
                      {this.props.library.email}{" "}
                    </a>
                  </div>
                ) : (
                  ""
                )}
                <div className="mobile_hidden">
                  <div className="small-title"> Округ</div>
                  <div> {this.props.library.region} </div>
                  <div className="small-title"> Район</div>
                  <div> {this.props.library.district} </div>
                </div>
                <div className="mobile_visible">
                  <div className="information-table">
                    {this.props.library.databases ? (
                      <div className="information_item">
                        <div className="small-title">
                          {" "}
                          Электронные базы данных
                        </div>
                        <div className="icon-arrow" />
                        <div
                          className="libraryToggleBlock"
                          onClick={e => this.showInformation(e)}
                        />
                        <div className="info_hide">
                          {this.props.library.databases.map(
                            (database, index) => {
                              return (
                                <div className="list" key={index}>
                                  {" "}
                                  - {database}{" "}
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.props.library.children.length ? (
                      <div className="information_item">
                        <div className="small-title"> Для детей</div>
                        <div className="icon-arrow" />
                        <div
                          className="libraryToggleBlock"
                          onClick={e => this.showInformation(e)}
                        />
                        <div className="info_hide">
                          {this.props.library.children.map((item, index) => {
                            const className = item.paid
                              ? "list list--paid"
                              : "list";
                            return (
                              <div className={className} key={index}>
                                {" "}
                                - {item.name}{" "}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.props.library.copy.length ? (
                      <div className="information_item">
                        <div className="small-title"> Копицентр</div>
                        <div className="icon-arrow" />
                        <div
                          className="libraryToggleBlock"
                          onClick={e => this.showInformation(e)}
                        />
                        <div className="info_hide">
                          {this.props.library.copy.map((item, index) => {
                            const className = item.paid
                              ? "list list--paid"
                              : "list";
                            return (
                              <div className={className} key={index}>
                                {" "}
                                - {item.name}{" "}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.props.library.services.length ? (
                      <div className="information_item">
                        <div className="small-title"> Услуги и курсы</div>
                        <div className="icon-arrow" />
                        <div
                          className="libraryToggleBlock"
                          onClick={e => this.showInformation(e)}
                        />
                        <div className="info_hide">
                          {this.props.library.services.map((service, index) => {
                            const className = service.paid
                              ? "list list--paid"
                              : "list";
                            return (
                              <div className={className} key={index}>
                                {" "}
                                - {service.name}{" "}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    style={{ paddingTop: "30px" }}
                    className="photo-container"
                    onClick={this.showGallery}
                  >
                    {this.props.library.photos.small.length > 2 ? (
                      <div className="more-photo">
                        <span className="more-photo-desc">
                          {" "}
                          {this.props.library.photos.small.length} фото{" "}
                        </span>
                        <img
                          src={`${process.env.REACT_APP_IMG_SERVER}/${
                            this.props.library.photos.small[2]
                          }`}
                          alt=""
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="icon">
                 {/* {this.props.library.fb ? (
                    <a
                      href={`http://${this.props.library.fb}`}
                      className="facebook"
                    >
                      {" "}
                    </a>
                  ) : (
                    ""
                  )}*/}
                  {/*{this.props.library.insta ? (
                    <a
                      href={`http://${this.props.library.insta}`}
                      className="insta"
                    >
                      {" "}
                    </a>
                  ) : (
                    ""
                  )}*/}
                  {/*{this.props.library.twi ? (
                    <a
                      href={`http://${this.props.library.twi}`}
                      className="twitter"
                    >
                      {" "}
                    </a>
                  ) : (
                    ""
                  )}*/}
                  {this.props.library.vk ? (
                    <a href={`http://${this.props.library.vk}`} className="vk">
                      {" "}
                    </a>
                  ) : (
                    ""
                  )}
                  {this.props.library.od ? (
                    <a href={`http://${this.props.library.od}`} className="ok">
                      {" "}
                    </a>
                  ) : (
                    ""
                  )}
   {this.props.library.blog ? (
                    <a href={`http://${this.props.library.blog}`} className="telegramm">
                      {" "}
                    </a>
                  ) : (
                    ""
                  )}
                  {this.props.library.video ? (
                    <a
                      href={`http://${this.props.library.video}`}
                      className="yotube"
                    >
                      {" "}
                    </a>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {Object.keys(this.props.library.paid_services).length ? (
          <div className="information-table margin-large">
            <div className="wide" style={{ width: "100%" }}>
              <div className="name">
                <p>Платные услуги</p>
              </div>
              <div>
                {this.props.library.paid_services.map(service => (
                  <div className="service-table" key={service.id}>
                    <div style={{ flex: "10% 0 0" }}>{service.name}</div>
                    <div style={{ flex: "60% 0 0 " }}>{service.desc}</div>
                    <div style={{ flex: "10% 0 0" }}>{service.type_name}</div>
                    <div style={{ flex: "10% 0 0" }}>{service.price} ₽</div>
                    <button
                      style={{
                        backgroundColor: "#9cc6ee",
                        padding: "0.5rem 1rem",
                        border: "none"
                      }}
                      onClick={() => this.showPayment(service)}
                    >
                      {" "}
                      Купить
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : null}
        {/*<div className="information-table feedback margin-large">
          <div>
            Поделитесь своими впечатлениями от посещения библиотек Москвы! Это
            поможет нам стать лучше. Пожалуйста, заполните короткую анкету из
            трех вопросов. Опрос анонимный.
          </div>
          <a
            href="https://ru.surveymonkey.com/r/BIBLIOPROS"
            target="_blank"
            rel="noreferrer noopener"
            className="arrow"
          />
        </div>*/}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  library: state.library.library,
  map: state.map,
  formUrl: state.order.formUrl
});

const mapDispatchToProps = dispatch => ({
  createOrder: bindActionCreators(order.actions.createOrder, dispatch),
  selectLibrary: bindActionCreators(map.actions.selectLibrary, dispatch),
  getAllLibraries: bindActionCreators(map.actions.getAllLibraries, dispatch),
  closeLibrary: bindActionCreators(library.actions.closeLibrary, dispatch)
});

export default withWrapper(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LibraryCard)
  )
);



// WEBPACK FOOTER //
// ./src/components/LibraryCard/LibraryCard.js